// extracted by mini-css-extract-plugin
export default {"methodOptionWrapper":"SelectOTPMethodModal__methodOptionWrapper--gCI5P","methodName":"SelectOTPMethodModal__methodName--o2P1l","active":"SelectOTPMethodModal__active--zhbLH"};